import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { PageableTableComponent } from '../../../../shared/controls/pageable-table/pageable-table.component';

import { InitializerService } from '../../../../shared/services/initializer-service';
import { ErrorService } from '../../../../shared/services/error-service';

import { AuditRequestService, FilteredAuditRequestItem, PagingData } from '../../../../../service/proxy';

@Component({
    selector: 'app-audit-request',
    templateUrl: './audit-request.component.html',
    styleUrls: ['./audit-request.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
        PageableTableComponent,
    ],

    providers: [
        AuditRequestService,
    ]
})
export class AuditRequestComponent implements OnInit {
    public search: string = '';
    public paging: PagingData = new PagingData();
    public auditRequests:  FilteredAuditRequestItem[] = [];
    public requestId: string = '';
    public auditRequest: any = {};

    constructor(
        private route: ActivatedRoute,
        private auditRequestService: AuditRequestService,
        private initializerService: InitializerService,
        private errorService: ErrorService)
        {
            this.paging = this.initializerService.createPagingData();
        }

    ngOnInit(): void {
        this.requestId = this.route.snapshot.paramMap.get('id') || '';

        if (this.requestId) {
            this.getAuditRequests(this.paging);
        }
    }

    refreshGridData(): void {
        this.paging = this.initializerService.createPagingData();
        this.getAuditRequests(this.paging);
    }

   getAuditRequests(pagingData: PagingData): void {
        if (this.requestId) {
            (this.auditRequestService.getFilteredAuditRequests as any)(
                this.search,
                pagingData.pageNo,
                pagingData.pageSize,
                pagingData.sortDirection,
                pagingData.sortColumn,
                this.requestId
            ).subscribe({
                next: (data: any) => {
                    this.paging = data.pagingData;
                    this.auditRequests = data.results || [];
                },
                error: (error: any) => {
                    if (error.status === 204) {
                        this.auditRequests = [];
                        this.paging = this.initializerService.createPagingData();
                    }
                    else {
                        this.errorService.handleError(error);
                    }
                }
            });
        }
    }

    getColumnMap() {
        return {
            requestId: 'Request Id',
            requestEmail: 'Request Email',
            requestedUrl: 'Requested Url',
            refererUrl: 'Referer Url',
            accepts: 'Accepts',
            createdAt: 'Created At',
        };
    }
}